import { FormattedMessage } from 'react-intl';

import { Heading } from '@shieldpay/bumblebee/heading';
import TopBarMarkdown from '@shieldpay/bumblebee/markdown/top-bar.md';

import { TopBar } from '@shieldpay/utilities-ui/top-bar';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.topBar.title',
});

export const TopBarComponentPage = () => {
  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.topBar.title" />
      </Heading>

      <ContentsTable />

      {/* custom padding to provide correct white space for top bar to sit in */}
      <ComponentPreview padding={{ top: 'none', bottom: 'basePos11' }}>
        <TopBar
          email="vera.boca@italo.disco"
          role="Top Business Manager"
          logOutText="Log out"
          logOutHref="/"
        />
      </ComponentPreview>

      <MdxFormatter md={TopBarMarkdown} />
    </>
  );
};

export default TopBarComponentPage;
